// import node module libraries
import { Col, Image, ListGroup, Row } from "react-bootstrap";

// import custom components
import SectionHeadingLeftBold from "components/marketing/common/section-headings/SectionHeadingLeftBold";

// import MDI icons
import { mdiCheckCircle } from "@mdi/js";
import Icon from "@mdi/react";

// import media files
import FeaturedImg1 from "assets/images/png/rivals.png";

const Rivales = () => {
  const title = "Monitorea los precios de tu competencia";
  const subtitle = "Market Radar";
  const description =
    "Da de alta tus rivales y monitorea sus precios en tiempo real para ajustar tus estrategias de venta y mantenerte competitivo en el mercado.";

  const featurescol1 = [
    { content: "Histórico de precios" },
    { content: "Monitoreo de precios 24/7" },
    { content: "Alertas ante cambios de precios" },
  ];
  const featurescol2 = [
    { content: "Priorización por impacto" },
    { content: "Tendencias y estacionalidad" },
    { content: "Detección de guerras de precios" },
  ];

  return (
    <Row className="align-items-center">
      <Col lg={6} md={12} xs={12}>
        {/* image */}
        <div className="mb-4 mb-lg-0 bg-gray-100 rounded-4 ">
          <Image src={FeaturedImg1} alt="..." className="img-fluid w-100" />
        </div>
      </Col>
      <Col lg={6} md={12} xs={12} className="mt-4 mt-lg-0">
        {/* content */}
        <div className="ps-lg-7">
          <SectionHeadingLeftBold title={title} description={description} subtitle={subtitle} />
          <Row className="mt-5">
            {/* list */}
            <Col>
              <ListGroup bsPrefix="list-unstyled" className="fs-4 fw-medium">
                {featurescol1.map((item, index) => {
                  return (
                    <ListGroup.Item key={index} bsPrefix="mb-2" className="d-flex">
                      <Icon path={mdiCheckCircle} size={0.7} className="text-success mt-1 me-2" />{" "}
                      {item.content}
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            </Col>
            <Col>
              {/* list */}
              <ListGroup bsPrefix="list-unstyled" className="fs-4 fw-medium">
                {featurescol2.map((item, index) => {
                  return (
                    <ListGroup.Item key={index} bsPrefix="mb-2" className="d-flex">
                      <Icon path={mdiCheckCircle} size={0.7} className="text-success mt-1 me-2" />{" "}
                      {item.content}
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default Rivales;
